import styled, { css } from 'styled-components';
import { LARGE_SCREEN_WIDTH_REM } from '../../utils/constants';

const rtlSwitch = dir => (dir === 'rtl' ? 'left' : 'right');
const textDirection = dir => (dir === 'rtl' ? 'right' : 'left');

const noSelectHighlight = css`
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

export const ScrollArea = styled.div`
  ${noSelectHighlight}
  overflow-x: hidden;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s;
  will-change: transform;
  user-select: none;
  ${({ theme: { dir, fullScreen } }) =>
    fullScreen
      ? `
        padding: 1rem 0 1.5rem;
        overflow-y: auto;
      `
      : `
      white-space: nowrap;
      height: 7.75rem;
      overflow-y: hidden;
      ${dir !== 'rtl' ? `padding: 1rem 0 1rem 1.5rem` : `padding: 1rem 1.5rem 1rem 0`};
      touch-action: none;
      @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
        overflow: visible;
        padding-${/* sc-custom "left" */ textDirection(dir)}: 0;
        height: 8.375rem;
      }
      `}
`;

export const StyledScrollBooster = styled.div`
  ${({ theme: { dir, fullScreen } }) =>
    fullScreen
      ? `
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
    `
      : `
      display: inline-block;
      min-width: 100%;
      border-right: 1.25rem solid transparent;
      @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
        && {
          transform: none !important;
        }
        border-right: 0;
        & > div: not(:last-of-type) {
          margin-${/* sc-custom "left" */ rtlSwitch(dir)}: 1.5rem;
        }
        & > div:last-of-type {
          margin-${/* sc-custom "left" */ rtlSwitch(dir)}: 0;
        }
      }
    `}
`;
